<template>    
<div class="main centerM">
    <div class="mt">
        <div class="hd">
            <div class="userImg">
                <img v-if="!avatar" src="@/assets/img/img_common_proshow_normal.png" alt="">
                 <img v-if="avatar" :src="avatar" alt="">
            </div>
            <a @click="()=> $router.push({name:'EditInfo'})">
                <img src="@/assets/img/i-right-grey.png" alt="">
            </a>
        </div>
        <div class="bd">
            <p class="userName text-ellipsis">
                {{user.nickname}}
            </p>
            <a class="userTag text-ellipsis"  @click="()=> $router.push({name:'EditInfo'})">
                编辑个人资料
            </a>
        </div>
    </div>
    <div class="mc">
        <ul>
            <li  @click="()=> $router.push({name:'BookManager'})">
                <a>
                    <div class="llabel">
                        <img src="@/assets/img/ic_menu_takeshow_normal.png" alt="">
                        借阅记录
                    </div>
                    <div class="rdiv">
                        已借{{user.borrowBook}}本书
                    </div>
                </a>
            </li>
            <li  @click="()=> $router.push({name:'Rule'})">
                <a>
                    <div class="llabel">
                        <img src="@/assets/img/ic_menu_rules_normal.png" alt="">
                        借阅规则
                    </div>
                    <div class="rdiv">
                        查看详情
                    </div>
                </a>
            </li>
            <li  @click="()=> $router.push({name:'Collect'})">
                <a>
                    <div class="llabel">
                        <img src="@/assets/img/ic_menu_myfavorite_normal.png" alt="">
                        我的收藏
                    </div>
                    <div class="rdiv">
                        查看收藏
                    </div>
                </a>
            </li>
            <li @click="()=> $router.push({name:'AgainstRecord'})">
                <a>
                    <div class="llabel">
                        <img src="@/assets/img/ic_menu_lllegal_normal.png" alt="">
                        违规记录
                    </div>
                    <div class="rdiv">
                        查看详情
                    </div>
                </a>
            </li>
        </ul>
    </div>
    <div class="mc nborder">
        <ul>
            <li @click="()=> $router.push({name:'Accout'})">
                <a>
                    <div class="llabel">
                        <img src="@/assets/img/ic_menu__usernum_normal.png" alt="">
                        账号绑定
                    </div>
                    <div class="rdiv">
                        修改
                    </div>
                </a>
            </li>
            <li @click="()=> $router.push({name:'Question'})">
                <a>
                    <div class="llabel">
                        <img src="@/assets/img/ic_menu_qaa_normal.png" alt="">
                        问题反馈
                    </div>
                    <div class="rdiv">
                        提交
                    </div>
                </a>
            </li>
        </ul>
    </div>
    <div class="mb">
        <ul class="nav-tab">
            <li>
                <a @click="()=> $router.push({name:'Books'})">
                    <img src="@/assets/img/tab1.png" alt="">
                    <p>图书信息</p>
                </a>
            </li>
            <li>
                <a @click="()=> $router.push({name:'Devices'})">
                    <img src="@/assets/img/tab2.png" alt="">
                    <p>地址找书</p>
                </a>
            </li>
            <li class="on"> 
                <a @click="()=> $router.push({name:'Center'})">
                    <img src="@/assets/img/tab3_on.png" alt="">
                    <p>个人中心</p>
                </a>
            </li>
        </ul>
    </div>
    <div class="modal-item modal-unlogin" :style="{'display':(unlogin?'block':'none')}">
        <p>
            您尚未登录，无法操作哟(￣^￣)
        </p>
        <div class="opts">
            <a @click="()=>$router.push({name:'Login'})" class="btn-or btn-login">
                前去登录
            </a>
            <a @click="()=>unlogin=false"class="btn-grey-2 btn-see">
                再看看
            </a>
        </div>
    </div>
</div>
</template>
<script>
import { USER } from "@/store/mutation-types";
import { getUserInfo } from "@/api/user";
export default {
  data() {
    return {
      user: {},
      avatar: null,
      resource_api: process.env.VUE_APP_RESOURCE_API,
      unlogin: false,
    };
  },
  methods: {
    handleUserInfo() {
      getUserInfo()
        .then((res) => {
          this.user = res.data;
          this.$ls.set(USER, res.data);
          if (this.user.avatar != null && this.user.avatar.length > 0) {
            if (this.user.avatar.substr(0, 4) == "http") {
              this.avatar = this.user.avatar;
            } else {
              this.avatar = this.resource_api + this.user.avatar;
            }
          }
        })
        .catch((error) => {
          console.log("error", error.response);
          if (error.response.status == 401) {
            this.unlogin = true;
          }
        });
    },
  },
  mounted() {
    //   this.user = this.$ls.get(USER)
    this.handleUserInfo();
    var deviceWidth;
    setHtmlFontSize();

    if (window.addEventListener) {
      window.addEventListener(
        "resize",
        function() {
          setHtmlFontSize();
        },
        false
      );
    }
    function setHtmlFontSize() {
      // 1920设计稿宽度
      deviceWidth =
        document.documentElement.clientWidth > 750
          ? 750
          : document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.cssText =
        "font-size:" + deviceWidth / 7.5 + "px !important";
    }
  },
};
</script>
<style lang="css">
@import "~@/assets/css/center.css";
</style>
